module.exports = __webpack_public_path__ + "img/choose-bg.664034b7.jpg";